import { PlusOutlined } from "@ant-design/icons";
import { Position } from "@xyflow/react";
import { TransparentHandle } from "components/CC/UI/TransparentHandle.tsx";

interface Props {
    onClick?: () => void;
}

// Match BaseNode dimensions: size=80, containerSize=85
const SIZE = 80;
const CONTAINER_SIZE = SIZE + 5;

export const EmptyBaseNode = ({ onClick }: Props) => {
    return (
        <div className="flex flex-col items-center">
            <div
                onClick={onClick}
                className="relative flex items-center justify-center"
                style={{ width: CONTAINER_SIZE, height: CONTAINER_SIZE }}
            >
                <TransparentHandle type={"target"} position={Position.Left} />
                <div
                    className="relative z-10 flex items-center justify-center cursor-pointer rounded-[50%]"
                    style={{ width: SIZE, height: SIZE }}
                >
                    <div className="absolute inset-0 border-4 border-dashed border-gray-300 rounded-[50%]" />
                    <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
                        <PlusOutlined className="text-gray-400 text-xl" />
                    </div>
                </div>
                <TransparentHandle type={"source"} position={Position.Right} />
            </div>
        </div>
    );
};
